import { render } from "./IconUI.vue?vue&type=template&id=6f1eae57&ts=true"
import script from "./IconUI.vue?vue&type=script&lang=ts"
export * from "./IconUI.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__